import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { baseURL } from '../apiConfig';
import './PrintPreview.css';

const PrintPreview = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const fromTag = queryParams.get('from');
    const toTag = queryParams.get('to');
    
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTags = async () => {
            try {
                const response = await fetch(`${baseURL}/api/get_tags_range/?from=${fromTag}&to=${toTag}`);
                const data = await response.json();
                if (data.success) {
                    setTags(data.tags);
                } else {
                    alert('Error fetching tags: ' + data.message);
                }
            } catch (error) {
                alert('Server error fetching tags');
            }
            setLoading(false);
        };
        
        if (fromTag && toTag) {
            fetchTags();
        } else {
            setLoading(false);
        }
    }, [fromTag, toTag]);

    useEffect(() => {
        if (!loading && tags.length > 0) {
            // Auto print after a short delay to allow fonts to load
            setTimeout(() => {
                window.print();
            }, 1000);
        }
    }, [loading, tags]);

    if (loading) return <div>Loading tags for printing...</div>;
    
    if (tags.length === 0) return <div>No tags found in this range.</div>;

    return (
        <div className="print-preview-container">
            {tags.map((tag, index) => (
                <div key={index} className="tag-page">
                    <div className="tag-container">
                        <div className="tag-left">
                            <div className="tag-item">{tag.item}</div>
                            <div className="tag-type">{tag.item_type}</div>
                            <div className="tag-category">{tag.category}</div>
                            <div className="tag-weight">Weight - {tag.weight}</div>
                        </div>
                        <div className="tag-right">
                            {/* Adding asterisks for Code39 barcode format */}
                            <div className="tag-barcode-font">*{tag.tag_text}*</div>
                            <div className="tag-bottom-row">
                                <div className="tag-number">{tag.tag_text}</div>
                                <div className="tag-making">{tag.making}</div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PrintPreview;
